import { FC } from "react";

interface LogoProps {
  readonly size?: "sm" | "md" | "lg";
}

interface LogoIconProps {
  readonly width?: number;
  readonly height?: number;
}

export const LogoIcon: FC<LogoIconProps> = ({ width = 216, height = 216 }) => (
  <svg
    fill="currentColor"
    stroke="currentColor"
    viewBox="0 0 216 216"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-scroll-text"
    aria-hidden="true"
  >
    <g transform="translate(-646.9737,-400.44461)">
      <path d="m 688.52898,615.34731 c -1.74189,-0.5043 -4.3778,-2.35577 -5.85757,-4.11438 -4.7306,-5.62199 -3.88986,-7.99218 17.67464,-49.82787 l 19.35002,-37.53954 -7,-6.96548 c -8.19658,-8.15616 -13.52435,-16.82707 -17.17701,-27.95543 -3.67016,-11.18168 -3.86678,-27.5172 -0.46339,-38.5 5.98805,-19.32356 17.93128,-33.77948 35.09287,-42.47591 7.24197,-3.66979 22.89031,-7.52409 30.54753,-7.52409 7.17979,0 23.15792,3.78414 29.60467,7.01134 7.22691,3.61775 18.27102,12.56904 23.09787,18.7209 16.80944,21.42378 19.58758,50.45922 7.13476,74.56824 -5.42645,10.50575 -18.19848,23.00433 -29.06606,28.44372 -11.62626,5.81913 -20.82585,7.66312 -34.6679,6.94895 -6.10684,-0.31508 -12.04129,-0.85793 -13.18768,-1.20632 -1.88487,-0.57283 -3.99025,3.08037 -22,38.1738 -23.02129,44.85883 -23.21038,45.10027 -33.08275,42.24207 z m 92.04451,-92.29554 c 32.31549,-12.28006 46.7168,-49.17079 31.44422,-80.54827 -4.83305,-9.92948 -16.18553,-20.89874 -26.87529,-25.96809 -14.04332,-6.65968 -31.03947,-7.46372 -45.0833,-2.13278 -14.33232,5.44045 -27.77249,18.77659 -33.40335,33.14482 -10.63474,27.13656 0.61255,57.62226 26.5403,71.93726 9.96948,5.50426 16.92815,7.02514 30,6.55675 8.26367,-0.2961 11.96478,-0.93285 17.37742,-2.98969 z m -13.67852,-15.38738 c -2.12952,-2.35309 -2.17714,-6.09199 -0.11508,-9.03599 1.36834,-1.95357 1.42407,-3.20832 0.40965,-9.22251 -1.02917,-6.10161 -1.44088,-6.96174 -3.33382,-6.96502 -2.89938,-0.005 -8.1696,-3.31871 -10.19536,-6.41042 -0.90441,-1.3803 -1.88694,-4.31807 -2.18341,-6.52837 -0.50902,-3.79505 -0.98079,-4.27772 -8.47612,-8.67193 -5.91597,-3.46829 -8.22582,-4.36448 -9.07093,-3.51937 -0.62361,0.62361 -2.86428,1.13383 -4.97928,1.13383 -5.14305,0 -8.75455,-3.50649 -8.75455,-8.5 0,-8.24643 10.11427,-11.7182 15.49816,-5.31982 1.83803,2.18437 2.55329,4.01589 2.28424,5.84906 -0.35108,2.39203 0.39195,3.14157 7.16295,7.2257 l 7.55465,4.55682 2.26589,-2.83357 c 4.64614,-5.81016 13.55589,-6.2686 19.54977,-1.0059 l 3.27289,2.87364 5.20572,-3.00551 c 4.02978,-2.32658 5.20573,-3.55644 5.20573,-5.4444 0,-3.1854 3.80799,-5.10433 6.87351,-3.46372 5.10214,2.73059 0.93242,10.6672 -4.34179,8.26411 -1.77835,-0.81027 -3.17073,-0.45135 -7.05936,1.81973 l -4.84407,2.82909 0.21729,5.32739 c 0.26807,6.57218 -2.33377,11.29776 -7.38167,13.40691 -2.85448,1.19268 -3.39341,1.86657 -2.95083,3.68982 0.2978,1.22686 0.87913,4.25555 1.29183,6.73042 0.59339,3.55846 1.3315,4.7783 3.52836,5.83123 1.5279,0.73231 3.22523,2.50777 3.77185,3.94547 2.13776,5.62274 -6.37738,10.89513 -10.40622,6.44331 z M 733.8274,490.92626 c -0.7523,-1.96047 0.96013,-5.48769 2.65385,-5.46634 2.39221,0.0302 3.88411,1.75115 3.55231,4.09778 -0.41417,2.92924 -5.20211,3.98506 -6.20616,1.36856 z m 26.9416,-48.05158 c -5.3584,-5.3584 -0.41124,-13.68251 7.02285,-11.81668 4.4622,1.11995 6.09298,8.54833 2.57548,11.73162 -2.31282,2.09307 -7.54396,2.13943 -9.59833,0.0851 z" />
    </g>
  </svg>
);

export const Logo: FC<LogoProps> = ({ size = "md" }) => {
  const sizeClasses = {
    sm: "size-8 text-lg",
    md: "size-12 text-xl",
    lg: "size-16 text-2xl",
  };

  return (
    <div
      className={`bg-primary/10 flex items-center justify-center rounded-full ${sizeClasses[size]}`}
    >
      <LogoIcon />
      <span className="sr-only">Buscador de Licitaciones</span>
    </div>
  );
};
